<template>
  <BaseModalEditCreate
    :mode="mode"
    :is-modified="false"
    @dismiss-changes="onDismissChanges"
    @save="onSave">
    <template #form>
      <div>
        <label for="name" class="text-sm font-medium">{{ $t('groups.name') }}</label>
        <BaseInput
          ref="editFieldRef"
          v-model="modifiedData.label"
          color="base"
          show-error-as-tooltip
          :error="$v.label.required.$invalid ? $v.label.required.$message : ''" />
      </div>
    </template>
  </BaseModalEditCreate>
</template>

<script setup lang="ts">
import { computed, nextTick, onMounted, ref } from 'vue';
import useVuelidate from '@vuelidate/core';
import { helpers, required } from '@vuelidate/validators';
import { deepCopy } from '@/utils/data';
import BaseModalEditCreate from './BaseModalEditCreate.vue';
import BaseInput from './BaseInput.vue';
import type { TreeType } from '@/types/ComponentTypes';

const props = defineProps<{
  mode: 'add' | 'edit';
  treeNode: TreeType;
}>();

const emit = defineEmits(['closeModal', 'save']);

const editFieldRef = ref<HTMLInputElement | null>(null);
onMounted(() =>
  nextTick(() => {
    editFieldRef.value?.focus();
  })
);

const modifiedData = ref<TreeType>({
  ...deepCopy<TreeType>(props.treeNode),
  uid: props.treeNode?.uid || 'default-uid',
});

function onDismissChanges() {
  emit('closeModal');
}

const validationModel = computed(() => ({
  label: modifiedData.value.label,
}));

const rules = computed(() => ({
  label: { required: helpers.withMessage('Name is required', required) },
}));

const $v = useVuelidate(rules, validationModel, { $lazy: true });

function onSave() {
  $v.value.$touch();
  if ($v.value.$invalid) return;
  emit('save', modifiedData.value);
}
</script>
